import "./forecast.css"
import React from 'react'
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemPanel, AccordionItemButton } from "react-accessible-accordion"

const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];


export default function Forecast({ data }) {
  const dayInWeek = new Date().getDay();
  //slice the data from exact day in week to whole length only as we required it only, mean if today is thursday then for next 7 days data 
  //will be sliced and then concat that to 0 index value till exact day
  //In simple words if wednesday then before concat it will o/p "Thursday","Friday","Saturday", "Sunday" but concat is joining
  //previous of wednesday like Monday,Tuesday and Wednesday to "Thursday", "Friday","Saturday", "Sunday" to make exact seven days
  //Final o/p=
  // 0: "Friday"
  // 1: "Saturday"
  // 2: "Sunday"
  // 3: "Monday"
  // 4: "Tuesday"
  // 5: "Wednesday"
  // 6: "Thursday"
  const foreCastDays = WEEK_DAYS.slice(dayInWeek, WEEK_DAYS.length).concat(WEEK_DAYS.slice(0, dayInWeek));
  const data1 = data.list.splice(0, 7);
  console.log(foreCastDays)
  return (
    <>
      <label className="title" >Weather Forecast for upcoming days</label>
      <Accordion allowZeroExpanded>
        {/* It is for accordion mean click to open like chrome and are built in chrome, here we are mapping data over */}
        {data1.map((item, idx) => (
          <AccordionItem key={idx}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <div className="daily-item">
                  <img alt="weather" className="icon-small" src={`icons/${item.weather[0].icon}.png`} />
                  <label className="day">{foreCastDays[idx]}</label>
                  <label className="description">{item.weather[0].description}</label>
                  <label className="description">{Math.round(item.main.temp)}&deg;C</label>


                </div>

              </AccordionItemButton>

            </AccordionItemHeading>
            <AccordionItemPanel> {/*It will expand */}
              <div className="daily-details-grid">
                <div className="daily-details-grid-item">
                  <label>Pressure</label>
                  <label>{item.main.pressure} hPa</label>

                </div>
                <div className="daily-details-grid-item">
                  <label>Humidity</label>
                  <label>{item.main.humidity}%</label>
                </div>
                <div className="daily-details-grid-item">
                  <label>Clouds</label>
                  <label>{item.clouds.all}%</label>
                </div>
                <div className="daily-details-grid-item">
                  <label>Wind Speed</label>
                  <label>{item.wind.speed} m/s</label>
                </div>
                <div className="daily-details-grid-item">
                  <label>Visibilty</label>
                  <label>{item.visibility * 0.001} km</label>
                </div>
                <div className="daily-details-grid-item">
                  <label>Feels Like</label>
                  <label>{Math.round(item.main.feels_like)}&deg;C</label>
                </div>
              </div>

            </AccordionItemPanel>

          </AccordionItem>


        ))}
      </Accordion>
    </>
  );
};
